import { User } from "../contexts/UserContext";

export const canManageDeadChecks = (user: User | null) => Boolean(
  user?.email?.toLowerCase() === "srubin@madisontitle.com" ||
  user?.roles?.some((role) => role.internalUserTeam?.name?.toLowerCase() === "development" &&
    role.internalUserRoleType?.name?.toLowerCase() === "developer")
);
